import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { fbAuth } from "../util";
import { Link } from "react-router-dom";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      error: null,
    };
  }
  handleSubmit = e => {
    e.preventDefault();
    fbAuth
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(() => {
        this.setState({ error: null });
      })
      .catch(error => {
        console.log({ error });
        this.setState({ error });
      });
  };
  handleKeyUp = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };
  logout = e => {
    e.preventDefault();
    fbAuth.signOut();
  };
  render() {
    const { error } = this.state;
    const { authed, user } = this.props;
    if (authed && user) {
      return (
        <>
          <h1>Hi.</h1>
          <p>
            Auto Assigned Queues are <Link to="/queue/auto/company">here.</Link>
          </p>
          <p>
            Queues are <Link to="/queue/company">here.</Link>
          </p>
          <p>
            The Manual Capture Queue is <Link to="/queue/manual">here.</Link>
          </p>
          <p>
            SEM information is <Link to="/sem">here.</Link>
          </p>
          <p>
            Split test URL admin is <Link to="/urls">here.</Link>
          </p>
          <p>
            <a onClick={this.logout} href="#">
              Log out
            </a>
          </p>
        </>
      );
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <h1>Login</h1>
        {error && (
          <p>
            Error:{" "}
            {error && error.message
              ? error.message
              : `Something wrong, please try again.`}
          </p>
        )}
        <FormGroup>
          <Label>Email</Label>
          <Input type="email" name="email" onChange={this.handleKeyUp} />
        </FormGroup>
        <FormGroup>
          <Label>Password</Label>
          <Input type="password" name="password" onChange={this.handleKeyUp} />
        </FormGroup>
        <FormGroup>
          <Button color="primary">Log In</Button>
        </FormGroup>
      </Form>
    );
  }
}

export default Login;
